import { render, staticRenderFns } from "./NewClaimModal.vue?vue&type=template&id=dedc1f1a&"
import script from "./NewClaimModal.vue?vue&type=script&lang=ts&"
export * from "./NewClaimModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports